module.exports = __webpack_public_path__ + "static/media/ergoapp4.21f7463e.png";